require('../../modules/es6.number.parse-int');
module.exports = parseInt;


/*****************
 ** WEBPACK FOOTER
 ** ../~/babel-runtime/~/core-js/library/fn/number/parse-int.js
 ** module id = 207
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/babel-runtime/~/core-js/library/fn/number/parse-int.js
 ** module id = 207
 ** module chunks = 1
 **/